import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface MappedProduct { mapping_id: number; product_id: number; product_code: string; name: string; category: string | null; unit_price: number | null; status: string }
export interface AvailableProduct { product_id: number; product_code: string; name: string; category: string | null; unit_price: number | null; status: string }
export interface MappedDealer { mapping_id: number; dealer_id: number; dealer_code: string; dealer_name: string; status: string }
export interface AvailableDealer { dealer_id: number; dealer_code: string; dealer_name: string; status: string }

export const clientMappingApi = {
  async products(clientId: number): Promise<MappedProduct[]> {
    return (await apiClient.get<ApiSuccess<MappedProduct[]>>('/client-products', { params: { clientId } })).data.data;
  },
  async availableProducts(clientId: number): Promise<AvailableProduct[]> {
    return (await apiClient.get<ApiSuccess<AvailableProduct[]>>('/client-products', { params: { clientId, available: true } })).data.data;
  },
  async mapProduct(clientId: number, productId: number): Promise<{ id: number }> {
    return (await apiClient.post<ApiSuccess<{ id: number }>>('/client-products', { clientId, productId })).data.data;
  },
  async unmapProduct(mappingId: number): Promise<void> {
    await apiClient.delete(`/client-products/${mappingId}`);
  },
  async dealers(clientId: number): Promise<MappedDealer[]> {
    return (await apiClient.get<ApiSuccess<MappedDealer[]>>('/client-dealers', { params: { clientId } })).data.data;
  },
  async availableDealers(clientId: number): Promise<AvailableDealer[]> {
    return (await apiClient.get<ApiSuccess<AvailableDealer[]>>('/client-dealers', { params: { clientId, available: true } })).data.data;
  },
  async mapDealer(clientId: number, dealerId: number): Promise<{ id: number }> {
    return (await apiClient.post<ApiSuccess<{ id: number }>>('/client-dealers', { clientId, dealerId })).data.data;
  },
  async unmapDealer(mappingId: number): Promise<void> {
    await apiClient.delete(`/client-dealers/${mappingId}`);
  },
};
